import React from "react";
import styled from "styled-components";
import Slide from "react-reveal/Slide";
import Zoom from "react-medium-image-zoom";
import "react-medium-image-zoom/dist/styles.css";

// style
const StyledProjectImage = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-around;
  margin: 1rem;
  .zoomed-image {
    display: flex;
    align-items: center;
    justify-content: center;
    img {
      height: 12rem;
      margin: 0.1rem;
    }
    :hover {
      img {
        opacity: 0.5;
        transition: 200ms;
      }
    }
  }

  // tablet
  @media screen and (min-width: 768px) {
    .zoomed-image {
      display: flex;
      align-items: center;
      justify-content: space-around;
      img {
        width: 100%;
        height: auto;
      }
    }
  }

  // 720 screen
  @media screen and (min-width: 1366px) {
    .zoomed-image {
      img {
        height: 14rem;
      }
    }

    // 1920k screen
    @media screen and (min-width: 1920px) {
    }
  }
`;
const ProjectImage = ({ imageOne, imageTwo, imageThree }) => {
  return (
    <StyledProjectImage>
      <Slide bottom>
        <div className="zoomed-image">
          <Zoom overlayBgColorEnd="rgba(0, 0, 0, 0.8)">
            <img src={imageOne} alt="gallery" height="100%" />
          </Zoom>
          <Zoom overlayBgColorEnd="rgba(0, 0, 0, 0.8)">
            <img src={imageTwo} alt="gallery" height="100%" />
          </Zoom>
          <Zoom overlayBgColorEnd="rgba(0, 0, 0, 0.8)">
            <img src={imageThree} alt="gallery" height="100%" />
          </Zoom>
        </div>
      </Slide>
    </StyledProjectImage>
  );
};

export default ProjectImage;
